import { useGetStateVariable } from '$tablet-app/src/app/state_variables';
import { StateVariableNames } from '$tablet-app/src/app/state_variables/state_variable_names';
import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import { StyleSheet, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import { ChatTextItem } from '../../ChatItem/types';
import { ChatOption } from './ChatTextOption';

interface Props {
  item: ChatTextItem;
  item_idx: number;
}

export const ChatTextBubble = ({ item, item_idx }: Props) => {
  const clearVisibleItem = useStateStore(
    (state) => state.clearDisplayedChatItem
  );

  const { data } = useGetStateVariable(
    StateVariableNames.ONLY_CHECKBOX_CHAT_OPTIONS
  );

  const dont_show_icons = data?.value === true;

  const selectChatOption = useStateStore((state) => state.selectChatOption);

  const handlePress = (value: string) => {
    selectChatOption(value, {
      open_item: true,
      idx: item_idx,
    });
  };

  const show_as_icons = item.data.options?.some((opt) => opt.icon?.length);

  const { width } = useWindowDimensions();
  const optionsAsColumns = show_as_icons && width >= 500;

  return (
    <TextBubble style={{ maxWidth: Math.min(width - 140, 420) }}>
      <TextBubbleCloseButton
        icon="times"
        onPress={clearVisibleItem}
        size="small"
      >
        Close
      </TextBubbleCloseButton>

      <TextBubbleScollView contentContainerStyle={styles.text_bubble_scroll}>
        {item.data.image_url?.length ? (
          <ResponseImage source={{ uri: item.data.image_url }} />
        ) : null}

        <Text variant="h3" weight="semibold" color="white">
          {item.data.text}
        </Text>

        {item.data.options ? (
          <Options style={optionsAsColumns ? styles.row_style : undefined}>
            {item.data.options?.map((option) => (
              <ChatOption
                column={optionsAsColumns}
                dont_show_icons={dont_show_icons}
                key={option.input?.value}
                option={option}
                onPress={handlePress}
              />
            ))}
          </Options>
        ) : null}
      </TextBubbleScollView>
    </TextBubble>
  );
};

const styles = StyleSheet.create({
  row_style: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 20,
  },
  text_bubble_scroll: {
    padding: 16,
    gap: 10,
  },
});

const TextBubbleScollView = styled.ScrollView`
  max-height: 500px;
`;

const TextBubbleCloseButton = styled(Button)`
  position: absolute;
  top: -55px;
  right: -16px;
`;

const TextBubble = styled.View`
  position: absolute;

  bottom: 90px;
  right: 130px;

  background-color: blue;
  border-radius: 10px;
  border-bottom-right-radius: 0px;

  background-color: rgba(5, 22, 51, 0.8);

  max-width: 420px;
`;

const Options = styled.View`
  gap: 10px;
`;

const ResponseImage = styled.Image`
  height: 200px;
  width: 200px;
  border-radius: 10px;
`;
